import { action, makeAutoObservable, observable } from 'mobx';
import { PlayingGameMode } from '../../core/enums/PlayingGameMode';

class ConfigStore {
  partnerId = 4;

  currencyCode = 'FUN';

  currencySymbol = null;

  partnerCurrencySymbol = null

  partnerCurrencyCode = 'FUN'

  demoBonusId = null;

  precision = 2

  rate = 1;

  mode = PlayingGameMode.Demo;

  language = 'en';

  resultHash = null;

  demoSpinId = null;

  demoBonusSpinId = null;

  showPlayForReal = true;

  constructor() {
    makeAutoObservable(this, {
      partnerId: observable.struct,
      currencyCode: observable.struct,
      currencySymbol: observable.struct,
      partnerCurrencySymbol: observable.struct,
      partnerCurrencyCode: observable.struct,
      demoBonusId: observable.struct,
      rate: observable.struct,
      precision: observable.struct,
      demoSpinId: observable.struct,
      demoBonusSpinId: observable.struct,
      language: observable.struct,
      mode: observable.struct,
      resultHash: observable.struct,
      setPartnerId: action.bound,
      setCurrencyCode: action.bound,
      setPartnerCurrencySymbol: action.bound,
      setPartnerCurrencyCode: action.bound,
      setCurrencySymbol: action.bound,
      setDemoBonusId: action.bound,
      setMode: action.bound,
      setLanguage: action.bound,
      setResultHash: action.bound,
      setDemoSpinId: action.bound,
      setDemoBonusSpinId: action.bound,
    });
  }

  setPartnerId(id) {
    this.partnerId = id;
  }

  setLanguage(lan) {
    this.language = lan;
  }

  setCurrencyCode(code) {
    this.currencyCode = this.currencySymbol || code;
  }

  setCurrencySymbol(symbol) {
    this.currencySymbol = symbol;
  }

  setPartnerCurrencySymbol(symbol) {
    this.partnerCurrencySymbol = symbol;
  }

  setPartnerCurrencyCode(code) {
    this.partnerCurrencyCode = code;
  }

  get partnerCurrencySymbolOrCode() {
    return this.partnerCurrencySymbol || this.partnerCurrencyCode
  }

  setDemoBonusId(bonusId) {
    this.demoBonusId = bonusId;
  }

  setMode(mode) {
    this.mode = mode;
  }

  setResultHash(hash) {
    this.resultHash = hash;
  }

  setDemoSpinId(id) {
    this.demoSpinId = id;
  }

  setDemoBonusSpinId(id) {
    this.demoBonusSpinId = id;
  }

  setRate(rate) {
    this.rate= rate
  }

  setPrecision(precision) {
    this.precision= precision
  }

  setShowPlayForReal(value) {
    this.showPlayForReal= value
  }
}

export const configStore = new ConfigStore();